import { Component, Input } from '@angular/core';
import { DashboardResponse } from '../../../api/models/dashboardResponse';

@Component({
    selector: 'created2',
    template: require('./dashboardCreated2.component.html')
})

export class Created2Component {

    public ham: boolean = false;

    @Input() dataSearch: DashboardResponse;
    @Input() status: any;

    constructor() {
        /* empty */
    }

    showHam() {
        this.ham = (this.ham) ? false : true;
    }    
}